import {
  FacebookAddToCart,
  GoogleAddToCart,
  SnapchatAddToCart,
} from './actions/addToCart'
import { FacebookEnter } from './actions/aroundTheWorldEnter'
import {
  FacebookCheckoutStepData,
  GoogleCheckoutStepData,
} from './actions/checkoutStepData'
import {
  FacebookCheckoutStepExtra,
  GoogleCheckoutStepExtra,
} from './actions/checkoutStepExtras'
import {
  FacebookBeginCheckout,
  GoogleBeginCheckout,
} from './actions/checkoutStepPayment'
import {
  FacebookCheckoutStepSummary,
  GoogleCheckoutStepSummary,
} from './actions/checkoutStepSummary'
import { FacebookEntryPoint, SnapchatEntryPoint } from './actions/entryPoint'
import { FacebookFollowStory, GoogleFollowStory } from './actions/followStory'
import {
  FacebookGiftcardAddToCart,
  GoogleGiftcardAddToCart,
  SnapchatGiftcardAddToCart,
} from './actions/giftcardAddToCart'
import {
  AdWordsGiftcardPurchase,
  BingGiftcardPurchase,
  FacebookGiftcardPurchase,
  GoogleGiftcardPurchase,
  SnapchatGiftcardPurchase,
} from './actions/giftcardPaymentComplete'
import {
  AdWordsSignup,
  FacebookSignup,
  GoogleSignup,
  SnapchatSignup,
} from './actions/newsletterSignUp'
import {
  AdWordsPurchase,
  BingPurchase,
  FacebookPurchase,
  GooglePurchase,
  MemberGetMemberPurchase,
  SnapchatPurchase,
} from './actions/paymentComplete'
import {
  FacebookProductDetails,
  GoogleProductDetails,
  SnapchatProductDetails,
} from './actions/productDetailPage'
import {
  AdWordsSpontaneitySignup,
  FacebookSpontaneitySignup,
  GoogleSpontaneitySignup,
  SnapchatSpontaneitySignup,
} from './actions/spontaneitySignUp'
import { EventTypes } from './middleware/ActionTypes'

type conversionType = (data: any) => any

const FacebookConversions = {
  dataConversion: new Map([
    [EventTypes.AROUND_THE_WORLD_ENTER, FacebookEnter as conversionType],
    [EventTypes.PRODUCT_DETAILS_PAGE, FacebookProductDetails as conversionType],
    [EventTypes.ADD_TO_CART, FacebookAddToCart as conversionType],
    [
      EventTypes.CHECKOUT_STEP_EXTRA,
      FacebookCheckoutStepExtra as conversionType,
    ],
    [EventTypes.CHECKOUT_STEP_DATA, FacebookCheckoutStepData as conversionType],
    [
      EventTypes.CHECKOUT_STEP_SUMMARY,
      FacebookCheckoutStepSummary as conversionType,
    ],
    [EventTypes.CHECKOUT_STEP_PAYMENT, FacebookBeginCheckout as conversionType],
    [
      EventTypes.GIFTCARD_ADD_TO_CART,
      FacebookGiftcardAddToCart as conversionType,
    ],
    [EventTypes.GIFTCARD_PURCHASE, FacebookGiftcardPurchase as conversionType],
    [EventTypes.NEWSLETTER_SIGNUP, FacebookSignup as conversionType],
    [
      EventTypes.SPONTANEITY_SIGNUP,
      FacebookSpontaneitySignup as conversionType,
    ],
    [EventTypes.FOLLOW_STORY, FacebookFollowStory as conversionType],
    [EventTypes.ENTRY_POINT, FacebookEntryPoint as conversionType],
    [EventTypes.PURCHASE, FacebookPurchase as conversionType],
  ]),
  nameConversion: new Map([
    [EventTypes.AROUND_THE_WORLD_ENTER, 'CompleteRegistration'],
    [EventTypes.PRODUCT_DETAILS_PAGE, 'ViewContent'],
    [EventTypes.ADD_TO_CART, 'AddToCart'],
    [EventTypes.CHECKOUT_STEP_EXTRA, 'Checkout'],
    [EventTypes.CHECKOUT_STEP_DATA, 'Checkout'],
    [EventTypes.CHECKOUT_STEP_SUMMARY, 'Checkout'],
    [EventTypes.CHECKOUT_STEP_PAYMENT, 'Checkout'],
    [EventTypes.GIFTCARD_ADD_TO_CART, 'AddToCart'],
    [EventTypes.GIFTCARD_PURCHASE, 'ViewContent'],
    [EventTypes.NEWSLETTER_SIGNUP, 'Lead'],
    [EventTypes.FOLLOW_STORY, 'Lead'],
    [EventTypes.ENTRY_POINT, 'ViewContent'],
    [EventTypes.PURCHASE, 'Purchase'],
  ]),
}

const GoogleConversions = {
  dataConversion: new Map([
    [EventTypes.PRODUCT_DETAILS_PAGE, GoogleProductDetails as conversionType],
    [EventTypes.ADD_TO_CART, GoogleAddToCart as conversionType],
    [EventTypes.CHECKOUT_STEP_EXTRA, GoogleCheckoutStepExtra as conversionType],
    [EventTypes.CHECKOUT_STEP_DATA, GoogleCheckoutStepData as conversionType],
    [
      EventTypes.CHECKOUT_STEP_SUMMARY,
      GoogleCheckoutStepSummary as conversionType,
    ],
    [EventTypes.CHECKOUT_STEP_PAYMENT, GoogleBeginCheckout as conversionType],
    [
      EventTypes.GIFTCARD_ADD_TO_CART,
      GoogleGiftcardAddToCart as conversionType,
    ],
    [EventTypes.GIFTCARD_PURCHASE, GoogleGiftcardPurchase as conversionType],
    [EventTypes.NEWSLETTER_SIGNUP, GoogleSignup as conversionType],
    [EventTypes.SPONTANEITY_SIGNUP, GoogleSpontaneitySignup as conversionType],
    [EventTypes.FOLLOW_STORY, GoogleFollowStory as conversionType],
    [EventTypes.PURCHASE, GooglePurchase as conversionType],
  ]),
  nameConversion: new Map([
    [EventTypes.PRODUCT_DETAILS_PAGE, 'view_item'],
    [EventTypes.CHECKOUT_STEP_EXTRA, 'begin_checkout'],
    [EventTypes.CHECKOUT_STEP_DATA, 'checkout_progress'],
    [EventTypes.CHECKOUT_STEP_SUMMARY, 'checkout_progress'],
    [EventTypes.CHECKOUT_STEP_PAYMENT, 'checkout_progress'],
    [EventTypes.GIFTCARD_ADD_TO_CART, 'add_to_cart'],
    [EventTypes.GIFTCARD_PURCHASE, 'purchase'],
    [EventTypes.NEWSLETTER_SIGNUP, 'signup'],
    [EventTypes.FOLLOW_STORY, 'follow'],
  ]),
}

const SnapchatConversions = {
  dataConversion: new Map([
    [EventTypes.ADD_TO_CART, SnapchatAddToCart as conversionType],
    [EventTypes.ENTRY_POINT, SnapchatEntryPoint as conversionType],
    [
      EventTypes.GIFTCARD_ADD_TO_CART,
      SnapchatGiftcardAddToCart as conversionType,
    ],
    [EventTypes.GIFTCARD_PURCHASE, SnapchatGiftcardPurchase as conversionType],
    [EventTypes.NEWSLETTER_SIGNUP, SnapchatSignup as conversionType],
    [
      EventTypes.SPONTANEITY_SIGNUP,
      SnapchatSpontaneitySignup as conversionType,
    ],
    [EventTypes.PRODUCT_DETAILS_PAGE, SnapchatProductDetails as conversionType],
    [EventTypes.PURCHASE, SnapchatPurchase as conversionType],
  ]),
  nameConversion: new Map([
    [EventTypes.ADD_TO_CART, 'ADD_CART'],
    [EventTypes.ENTRY_POINT, 'VIEW_CONTENT'],
    [EventTypes.GIFTCARD_ADD_TO_CART, 'ADD_CART'],
    [EventTypes.GIFTCARD_PURCHASE, 'VIEW_CONTENT'],
    [EventTypes.NEWSLETTER_SIGNUP, 'SIGN_UP'],
    [EventTypes.PRODUCT_DETAILS_PAGE, 'VIEW_CONTENT'],
    [EventTypes.PURCHASE, 'PURCHASE'],
  ]),
}

const AdWordsConversions = {
  dataConversion: new Map([
    [EventTypes.GIFTCARD_PURCHASE, AdWordsGiftcardPurchase as conversionType],
    [EventTypes.NEWSLETTER_SIGNUP, AdWordsSignup as conversionType],
    [EventTypes.SPONTANEITY_SIGNUP, AdWordsSpontaneitySignup as conversionType],
    [EventTypes.PURCHASE, AdWordsPurchase as conversionType],
  ]),
}

const BingConversions = {
  dataConversion: new Map([
    [EventTypes.GIFTCARD_PURCHASE, BingGiftcardPurchase as conversionType],
    [EventTypes.PURCHASE, BingPurchase as conversionType],
  ]),
}

const MemberGetMemberConversions = {
  dataConversion: new Map([
    [EventTypes.PURCHASE, MemberGetMemberPurchase as conversionType],
  ]),
}

export const conversions = {
  facebook: FacebookConversions,
  google: GoogleConversions,
  adWords: AdWordsConversions,
  bing: BingConversions,
  snapchat: SnapchatConversions,
  memberGetMember: MemberGetMemberConversions,
}
